import { useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { InvoiceDetailPanel } from "./InvoiceDetailPanel";

export const InvoiceCenter = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const navigate = useNavigate();
  const discardGuardRef = useRef<(() => boolean) | null>(null);

  if (!invoiceId) {
    return null;
  }

  const allowLeave = () =>
    !discardGuardRef.current || discardGuardRef.current();

  return (
    <InvoiceDetailPanel
      invoiceId={invoiceId}
      discardGuardRef={discardGuardRef}
      onBack={() => {
        if (!allowLeave()) return;
        navigate(-1);
      }}
      onCustomerClick={(customerId) => {
        if (!allowLeave()) return;
        navigate(`/customers/${customerId}`);
      }}
      navigateOnSendSuccess
    />
  );
};
